export default __webpack_public_path__ + "static/media/image2.17877b70.jpg";